import { z } from "zod";
import { FieldBaseSchema, defineControl } from "./field.js";
// The browser's own date and time input draws its own empty state, so there is
// no placeholder to give it. A value is a UTC instant as toISOString writes it,
// "2026-11-03T02:00:00.000Z", so one moment is one string. It is shown and
// entered in Perth time.
export const dateTimePicker = defineControl({
    key: "dateTimePicker",
    label: "Date and time picker",
    schema: FieldBaseSchema.extend({ control: z.literal("dateTimePicker") }),
    answer: z.iso.datetime({ precision: 3 }),
    isClearable: true,
    empty: { required: false },
});
